<template src="@/templates/document/transitionLetter.html"></template>

<script>
import TransitionLetterModel from "@/models/transitionLetterModel";

export default {
  name: "transitionLetter",
  data() {
    return {
      transitionLetterPopUp: true,
      transitionLetterModel: new TransitionLetterModel(),
      intEmail: localStorage.getItem("interpreterEmail"),
    };
  },
  created() {
    this.fetchTransitionLetter();
  },
  methods: {
    fetchTransitionLetter() {
      this.$vs.loading({
        type: "material",
      });

      this.transitionLetterModel
        .getLetterContent()
        .then((TLModelRes) => {
          let res = TLModelRes.response.data;

          if (res.error !== false) {
            this.fetchError(res.error);
            this.closeTransitionLetter();
          } else {
            this.transitionLetterModel.dbData = res;
          }

          this.$vs.loading.close();
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Network Error",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    closeTransitionLetter() {
      let sendLetter = false;
      Event.$emit("hideTransitionLetterComp", sendLetter);
    },
    sendTransitionLetter() {
      let sendLetter = true;
      Event.$emit("hideTransitionLetterComp", sendLetter);
    },
  },
};
</script>

<style scoped>
.con-vs-dialog {
  z-index: 40001 !important;
}
</style>
